import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import {
  MatDialogModule,
  MatFormFieldModule,
  MatButtonModule,
  MatInputModule,
} from '@angular/material';
import { FlexLayoutModule } from '@angular/flex-layout';
import { CovalentCommonModule, CovalentDialogsModule } from '@covalent/core';

import { DialogService } from './dialog.service';
import { PromptDialogComponent } from './prompt-dialog.component';

@NgModule({
  imports: [
    FormsModule, MatFormFieldModule, MatInputModule, MatButtonModule,
    MatDialogModule, FlexLayoutModule,
    CovalentCommonModule, CovalentDialogsModule
  ],
  exports: [ MatDialogModule ], // export material dialog components & directives
  providers: [ DialogService ],
  declarations: [ PromptDialogComponent ],
  entryComponents: [ PromptDialogComponent ]
})
export class DialogModule {
}

export function dialogModuleFactory() {
  return DialogModule;
}
